import {handleResponse} from "@/services/service-helpers.ts"

const BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/audit-logs`

export interface AuditLogEntry {
    id: string
    entityType: string
    action: string
    entityId: string | null
    entityName: string | null
    details: string | null
    createdAt: string
    createdBy: string
    createdByName: string | null
}

export interface AuditLogPageResponse {
    entries: AuditLogEntry[]
    page: number
    pageSize: number
    totalElements: number
    totalPages: number
}

export async function getAuditLogs(
    token: string | null,
    options?: {
        entityType?: string
        entityId?: string
        excludeEntityTypes?: string[]
        page?: number
        size?: number
    },
): Promise<AuditLogPageResponse> {
    if (!token) {
        return Promise.reject("No token provided")
    }

    const params = new URLSearchParams()
    if (options?.entityType) {
        params.set('entityType', options.entityType)
    }
    if (options?.entityId) {
        params.set('entityId', options.entityId)
    }
    if (options?.excludeEntityTypes) {
        for (const type of options.excludeEntityTypes) {
            params.append('excludeEntityTypes', type)
        }
    }
    if (options?.page !== undefined) {
        params.set('page', options.page.toString())
    }
    if (options?.size !== undefined) {
        params.set('size', options.size.toString())
    }

    const url = params.toString() ? `${BASE_URL}?${params}` : BASE_URL

    const response = await fetch(url, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }),
    })

    const result = await handleResponse<AuditLogPageResponse>(response)
    return result || { entries: [], page: 0, pageSize: 20, totalElements: 0, totalPages: 0 }
}

export async function exportAuditLogs(
    token: string | null,
    options?: {
        entityType?: string
        excludeEntityTypes?: string[]
    },
): Promise<AuditLogPageResponse> {
    if (!token) {
        return Promise.reject("No token provided")
    }

    const params = new URLSearchParams()
    if (options?.entityType) {
        params.set('entityType', options.entityType)
    }
    if (options?.excludeEntityTypes) {
        for (const type of options.excludeEntityTypes) {
            params.append('excludeEntityTypes', type)
        }
    }

    const url = params.toString() ? `${BASE_URL}/export?${params}` : `${BASE_URL}/export`

    const response = await fetch(url, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }),
    })

    const result = await handleResponse<AuditLogPageResponse>(response)
    return result || { entries: [], page: 0, pageSize: 0, totalElements: 0, totalPages: 0 }
}

export async function getMemberAuditLogs(
    token: string | null,
    memberId: string,
    options?: {
        page?: number
        size?: number
    },
): Promise<AuditLogPageResponse> {
    return getAuditLogs(token, {
        entityType: 'MEMBER',
        entityId: memberId,
        page: options?.page,
        size: options?.size,
    })
}
